<!--style using tailwindcss-typography-->
<div class="prose prose-sm max-w-none font-medium dark:prose-invert text-gray-800">
    <markdown class="list-disc" [data]="data()"></markdown>
</div>
